import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  customTables: state.customTables, 
  themeName: state.settings.items.theme.data.themeName 
}))
class CustomTableView extends React.Component {
  render() {
    const {
      classes,
      viewLoading,
      themeName,
      canCreateItem,
      onDeleteCustomTable,
      onEditCustomTable,
      onNewCustomTable,
      customTables: { 
        selectedCustomTable, 
        data: { 
          content: customTablesData, 
          pagination: { 
            number: currentPage, 
            size, 
            totalPages, 
            totalElements 
          } 
        }
      },
      onSelectCustomTable,
      onRefreshCustomTables,
      onFetchCustomTablesOnPage,
    } = this.props;

    const headerColor = getColorFromThemeName(themeName);

    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(customTablesData) ?
            <Card style={{ overflow: 'scroll' }}>
              <Table size="small" className={classes.table} elevation={4}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="customTables" />
                        </h3>
                        <IconButton onClick={() => onRefreshCustomTables()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 style={{ color: '#3f3f3f', fontSize: 16, fontWeight: 'bold' }}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="customTablesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCustomTablesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCustomTablesOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="tableName" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="description" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="fieldsCount" /></h4></TableCell>
                    <TableCell colSpan={4}><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(customTablesData, (customTable) => (
                    <TableRow
                      key={customTable.id}
                      className={classes.row}
                      hover
                      classes={{
                        selected: classes.rowSelected,
                        hover: classes.rowHovered,
                      }}
                      onClick={event => onSelectCustomTable(customTable)}
                      selected={selectedCustomTable && selectedCustomTable.id === customTable.id}
                    >
                      <TableCell>
                        <div style={{ marginTop: 0, marginBottom: 15, marginTop: 15, minWidth: 200, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 16 }}>{customTable.name}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div style={{ marginTop: 0, marginBottom: 15, marginTop: 15, minWidth: 200, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 16 }}>{customTable.description}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <h5 style={{ lineHeight: '1.5', fontSize: 14, marginTop: 10 }}>
                            {customTable.fields ? customTable.fields.length : 0}
                          </h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                          {canCreateItem ? (
                            <Button
                              onClick={(event) => {
                                event.stopPropagation();
                                onDeleteCustomTable(customTable.id);
                              }}
                              className={classes.button}
                            >
                              <Entity entity="delete" />
                              <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                            </Button>
                          ) : null}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 style={{ color: '#3f3f3f', fontSize: 16, fontWeight: 'bold' }}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="customTablesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCustomTablesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCustomTablesOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noCustomTables"
                    onNewEntity={canCreateItem ? () => onNewCustomTable() : null}
                    newEntityTitle="addCustomTable"
                    subtitle="startCustomTables"
                    iconName="icon-simple-line-icons-user-following"
                  />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CustomTableView); 